
export class ExceptionManager {

    getHttpResponseMessage(error: any) {
        switch (error.status) {
            case 0:
                return error.statusText;
            case 401:
                return "401 Unauthorized: The request requires user authentication.";
            case 404:
                return "404 Not Found: The server has not found anything matching the Request-URI.";
            case 500:
                return "500 Internal Server Error: The server encountered an unexpected condition which prevented it from fulfilling the request.";
            case 503:
                return "503 Service Unavailable.";
            default:
                return error.toString();
        }
    }
}